import React from 'react'
import { Link } from 'react-router-dom'
import * as Scroller from 'react-scroll'
import { useLocation } from 'react-router'
import MyCircle from './Works/MyCircles'
import Oudi from './Works/Oudi'
import Broadcast from './Works/Broadcast'
import Medusa from './Works/Medusa'
import Gravity from './Works/Gravity'
import Vigho from './Works/Vigho'
import Kallwealth from './Works/Kallwealth'
import DavidAyo from './Works/Davidayo'
import MobilePlay from './Works/MobilePlay'
import DesignPlay from './Works/DesignPlay'
import DriveMaster from './Works/DriveMaster'


function Work() {

    const { pathname } = useLocation()
    
    React.useEffect(() => {
        Scroller.animateScroll.scrollToTop()
    }, [pathname])

    const [workList] = React.useState([
        "/Work/mycircles",
        "/Work/oudi",
        "/Work/broadcast",
        "/Work/medusa",
        "/Work/gravity",
        "/Work/vigho",
        "/Work/kallwealth",
        "/Work/davidayo",
        // "/Work/mycircles",
        // "/Work/drivemaster",
        // "/Work/designplay",
        // "/Work/mobileplay",
        "/Work/mycircles",
    ])

    function renderPage() {
        switch (workList.indexOf(pathname)) {
            case 0:
                return <MyCircle />
            case 1:
                return <Oudi />
            case 2:
                return <Broadcast />
            case 3:
                return <Medusa />
            case 4:
                return <Gravity />
            case 5:
                return <Vigho />
            case 6:
                return <Kallwealth />
            case 7:
                return <DavidAyo />
            case 8:
                return <DriveMaster />
            case 9:
                return <DesignPlay />
            case 10:
                return <MobilePlay />

            default:
                return <MyCircle />
        }
    }

    function prev() {
        let theIndex = workList.indexOf(pathname) || 0

        theIndex >= 1 ? console.log(workList[theIndex - 1]) : console.log(workList[workList.length - 1])
        return theIndex >= 1 ? workList[theIndex - 1] : workList[workList.length - 2]
    }

    function next() {
        let theIndex = workList.indexOf(pathname) || 0
        console.log(pathname)

        theIndex < 10 ? console.log(workList[theIndex + 1]) : console.log(workList[0])
        return theIndex >= 1 ? workList[theIndex + 1] : workList[1]
    }


    return (
        <div>
            <div className="footer_mobile">
                <div className="arrows_mobile">
                    <Link className="mobile_previous" to={prev()}>
                        Previous
                    </Link>
                    <Link className="mobile_next" to={next()}>
                        Next
                    </Link>
                </div>
            </div>
            <div id="arrows">
                <Link className="arrow_previous" to={prev()}></Link>
                <Link className="arrow_next" to={next()}></Link>
            </div>
            <div className=" animated delay04 fadeInIn">
                {renderPage()}
            </div>
            <div className="footer_work_back">
                <Link className="work_btn" to={"/"}>Go back</Link>
            </div>
        </div>
    )
}

export default Work